export const formatSectionId = (section: { [x: string]: any }) => {
	if (section.displayName) return section.displayName.replace(/\s+/g, '-').toLowerCase()
	else return section.name.replace(/\s+/g, '-').toLowerCase()
}
